module.exports = __webpack_public_path__ + "public/StoreIcon/Uparrowwithcircle30x30.svg?db860c5e";